/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Tile_PaceInputs */

const en_ui_thresholds_tile_pace = /** @type {(inputs: Ui_Thresholds_Tile_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Threshold pace`)
};

const de_ui_thresholds_tile_pace = /** @type {(inputs: Ui_Thresholds_Tile_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo`)
};

/**
* | output |
* | --- |
* | "Threshold pace" |
*
* @param {Ui_Thresholds_Tile_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_tile_pace = /** @type {((inputs?: Ui_Thresholds_Tile_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Tile_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_tile_pace(inputs)
	return de_ui_thresholds_tile_pace(inputs)
});